"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const language_1 = require("~/contexts/language");
const subject_category_1 = require("~/contexts/subject-category");
const user_1 = require("~/contexts/user");
const react_router_dom_1 = require("react-router-dom");
const shared_data_1 = require("../../contexts/shared-data");
const jit_load_1 = __importDefault(require("~/helpers/jit-load"));
const salesforce_1 = require("~/contexts/salesforce");
const _404_1 = __importDefault(require("~/pages/404/404"));
function AppContext({ children }) {
    return (react_1.default.createElement(shared_data_1.SharedDataContextProvider, null,
        react_1.default.createElement(user_1.UserContextProvider, null,
            react_1.default.createElement(language_1.LanguageContextProvider, null,
                react_1.default.createElement(subject_category_1.SubjectCategoryContextProvider, null, children)))));
}
const importContact = () => Promise.resolve().then(() => __importStar(require('~/pages/contact/contact.js')));
function EmbeddedApp() {
    return (react_1.default.createElement(salesforce_1.SalesforceContextProvider, null,
        react_1.default.createElement(react_router_dom_1.Routes, null,
            react_1.default.createElement(react_router_dom_1.Route, { path: "contact", element: react_1.default.createElement(jit_load_1.default, { importFn: importContact }) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "*", element: react_1.default.createElement(_404_1.default, null) }))));
}
const importRouter = () => Promise.resolve().then(() => __importStar(require('./import-router.js')));
function App() {
    return (react_1.default.createElement(AppContext, null,
        react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
            react_1.default.createElement(react_router_dom_1.Routes, null,
                react_1.default.createElement(react_router_dom_1.Route, { path: "/embedded/*", element: react_1.default.createElement(EmbeddedApp, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "*", element: react_1.default.createElement(jit_load_1.default, { importFn: importRouter }) })))));
}
exports.default = react_1.default.createElement(App);
